import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

// Components
import TranslationSectionSearch from "./TranslationSectionSearch";
import TranslationSection from "./TranslationSection";

// State
import { setpageTitle } from "../../../store/actions/siteInfo";
import { addRoute } from "../../../store/actions/route";

class AdminTranslations extends Component {
	constructor(props) {
		super(props);
		this.props.addRoute(this.props.match);
		this.props.setpageTitle("Translate Sections");
	}

	render() {
		return (
			<React.Fragment>
				<h1>Translate Sections</h1>

				<Switch>
					<Route
						path={"/admin/translations"}
						exact
						component={TranslationSectionSearch}
					/>
					<Route path={"/admin/translations/:id"} component={TranslationSection} />
				</Switch>
			</React.Fragment>
		);
	}
}

export default connect(
	null,
	{ addRoute, setpageTitle }
)(AdminTranslations);



// WEBPACK FOOTER //
// ./src/components/admin/translations/AdminTranslations.js